export default __webpack_public_path__ + "static/media/back-black.d7b74411.svg";